import React, { useState } from 'react';

const FallbackImage = ({ src, alt, className, style, fallback }) => {
  const [error, setError] = useState(false);

  if (!src || error) {
    return fallback;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      onError={() => setError(true)}
    />
  );
};

export default React.memo(FallbackImage);
